export { default } from "./common-dialog";
